import React from "react";
import { Card, Grid } from "@mui/material";
import Title from "./../ReusableComponents/title";
import ResultByCloseChart from "../Charts/ResultByClose";
import ResultByOpenChart from "../Charts/ResultByOpen";
import ResultbyDaysTable from "./ResultByDaysTable";
import CommonTable from "./CommonTable";
import { dollarUS } from "../../utilities/formatters";

const ResultbyDays = ({ data }) => {
  console.log("ResultByCloseChart Data:", data);

  // const dummyDta = [
  //   {
  //     close: 765,
  //     no_of_trades: 2,
  //     open: 987,
  //   },
  //   {
  //     close: 765,
  //     no_of_trades: 2,
  //     open: 987,
  //   },
  //   {
  //     close: 765,
  //     no_of_trades: 2,
  //     open: 987,
  //   },
  //   {
  //     close: 765,
  //     no_of_trades: 2,
  //     open: 987,
  //   },
  //   {
  //     close: 765,
  //     no_of_trades: 2,
  //     open: 987,
  //   },
  //   {
  //     close: 765,
  //     no_of_trades: 2,
  //     open: 987,
  //   },
  //   {
  //     close: 765,
  //     no_of_trades: 2,
  //     open: 987,
  //   },
  // ];
  const tableData = Object.keys(data).map((day) => ({
    day,
    open: data[day].open,
    close: data[day].close,
  }));

  // Define columns with only Open and Close columns
  const columns = React.useMemo(
    () => [
      {
        Header: "Day",
        accessor: "day",
      },
      {
        Header: "Open",
        accessor: "open",
        Cell: ({ value }) => (
          <>
            <p
              className={`${
                value > 0 ? "profit_val" : value < 0 ? "loss_val" : ""
              }`}
            >
              {dollarUS(value)}
            </p>
          </>
        ),
      },
      {
        Header: "Close",
        accessor: "close",
        Cell: ({ value }) => (
          <>
            <p
              className={`${
                value > 0 ? "profit_val" : value < 0 ? "loss_val" : ""
              }`}
            >
              {dollarUS(value)}
            </p>
          </>
        ),
      },
    ],
    []
  );

  return (
    <div className="ResultByClose">
      {/* <Grid container item xs={12} spacing={3} sx={{ paddingTop: "0px" }}>
        <Grid className='result-days' item xs={12} lg={6}>
          <Card className="card-csc" sx={{marginLeft:'15px'}}>
            <Title six>Results by close</Title>
            <ResultByCloseChart data={data} />
          </Card>
        </Grid>
        <Grid item xs={12} lg={6}>
          <Card className="card-csc">
            <Title six>Results by Open</Title>
            <ResultByOpenChart data={data} />
          </Card>
        </Grid>
      </Grid> */}

      <Title six>Results by Days</Title>
      <Card className="card-csc" sx={{ marginLeft: "15px" }}>
        {/* <ResultbyDaysTable data={dummyDta} /> */}
        <CommonTable data={tableData} columns={columns} />
      </Card>
    </div>
  );
};

export default ResultbyDays;
